module.exports = __webpack_public_path__ + "img/avatar-7.bae8e081.jpg";